import opt1_neutral from "./Option_1_neutral.png";
import opt1_selected from "./Option_1_selected.png";
import opt1_result from "./Option_1_result.png";
import opt2_neutral from "./Option_2_neutral.png";
import opt2_selected from "./Option_2_selected.png";
import opt2_result from "./Option_2_result.png";
import opt3_neutral from "./Option_3_neutral.png";
import opt3_selected from "./Option_3_selected.png";
import opt3_result from "./Option_3_result.png";
import opt4_neutral from "./Option_4_neutral.png";
import opt4_selected from "./Option_4_selected.png";
import opt4_result from "./Option_4_result.png";

export const question1 = {
	option1: {
		opt1_neutral,
		opt1_selected,
		opt1_result,
	},
	option2: {
		opt2_neutral,
		opt2_selected,
		opt2_result,
	},
	option3: {
		opt3_neutral,
		opt3_selected,
		opt3_result,
	},
	option4: {
		opt4_neutral,
		opt4_selected,
		opt4_result,
	},
}